var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendarHeartBold(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.3175 55H12.5C11.1739 55 9.90215 54.4732 8.96447 53.5355C8.02678 52.5979 7.5 51.3261 7.5 50V15C7.5 13.6739 8.02678 12.4021 8.96447 11.4645C9.90215 10.5268 11.1739 10 12.5 10H47.5C48.8261 10 50.0979 10.5268 51.0355 11.4645C51.9732 12.4021 52.5 13.6739 52.5 15V27.8125",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 5V15M7.5 25H52.5M20 5V15M36.55 47C36.024 46.4516 35.6146 45.8024 35.3465 45.0915C35.0783 44.3806 34.957 43.6227 34.9898 42.8636C35.0226 42.1045 35.2088 41.3599 35.5373 40.6747C35.8657 39.9896 36.3296 39.3781 36.9009 38.8771C37.4721 38.3761 38.139 37.9961 38.8611 37.7599C39.5833 37.5238 40.3459 37.4364 41.1028 37.503C41.8596 37.5696 42.5952 37.7889 43.265 38.1476C43.9348 38.5063 44.525 38.9969 45 39.59C45.4773 39.0031 46.068 38.5186 46.7369 38.1653C47.4057 37.812 48.139 37.5972 48.8927 37.5338C49.6465 37.4704 50.4053 37.5597 51.1238 37.7964C51.8422 38.033 52.5056 38.4121 53.0742 38.9111C53.6427 39.41 54.1048 40.0185 54.4328 40.7001C54.7608 41.3817 54.9479 42.1225 54.983 42.8781C55.0181 43.6337 54.9004 44.3887 54.637 45.0978C54.3736 45.8069 53.9699 46.4555 53.45 47.005L46.885 54.145C46.6508 54.4147 46.3614 54.6309 46.0364 54.7791C45.7114 54.9273 45.3584 55.004 45.0012 55.004C44.6441 55.004 44.2911 54.9273 43.9661 54.7791C43.6411 54.6309 43.3517 54.4147 43.1175 54.145L36.55 47Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarHeartBold);
export default __webpack_public_path__ + "static/media/calendarHeart-bold.306c13baa8567459b957ba6917c86773.svg";
export { ForwardRef as ReactComponent };